export default __webpack_public_path__ + "static/media/box1.1428765b.png";